import { all, fork, put, takeEvery } from "redux-saga/effects";

import {

    // Membership Management
    SETTING_LOAD_MEMBERSHIP_CATEGORY,
    SETTING_CREATE_MEMBERSHIP_CATEGORY,
    SETTING_UPDATE_MEMBERSHIP_CATEGORY,
    SETTING_DELETE_MEMBERSHIP_CATEGORY,

    SETTING_LOAD_MEMBERSHIP,
    SETTING_CREATE_MEMBERSHIP,
    SETTING_UPDATE_MEMBERSHIP,
    SETTING_DELETE_MEMBERSHIP,

    // SETTING_LOAD_ALL_MEMBERSHIP_CUSTOMER,
    // SETTING_UPDATE_MEMBERSHIP_STATUS,
    // END Membership Management

} from "../../actions";

import {
    // Membership Management
    settingGetMembershipCategory,
    settingAddMembershipCategory,
    settingUpdateMembershipCategory,
    settingDeleteMembershipCategory,

    settingGetMembership,
    settingAddMembership,
    settingUpdateMembership,
    settingDeleteMembership,
    // settingGetAllMembershipCustomer,
    // settingUpdateChangeStatusMembership,

    // END Membership Management

} from "../../../helpers/setting-api";

import {
    getMembershipCategory,
    getMembershipCategorySuccess,
    getMembership,
    getMembershipSuccess,
    // getAllMembershipCustomer,
    // getAllMembershipCustomerSuccess,
} from "./actions";

import { NotificationManager } from '../../../components/common/react-notifications';

const PullNotificationManager = async (text) => {
    // eslint-disable-next-line no-return-await
    await NotificationManager.warning(text, 'Error', 3000, null, null, '');
}

// Membership Management
function* settingManagementLoadMembershipCategory({ payload, token }) {
    try {
        const dataRes = yield settingGetMembershipCategory(payload, token);
        if (dataRes.status === 'success') {
            // let list = [];
            // const dataFilter = dataRes.data.filter(el => el.name_department === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_department !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_membership_category,
                    value: item.id_membership_category,
                }
            ));
            yield put(getMembershipCategorySuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddMembershipCategory({ payload, token }) {
    try {
        const dataRes = yield settingAddMembershipCategory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getMembershipCategory({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateMembershipCategory({ payload, token }) {
    try {
        const dataRes = yield settingUpdateMembershipCategory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getMembershipCategory({ spa_id: payload.spa_id }, token));
            yield put(getMembership({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeleteMembershipCategory({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeleteMembershipCategory(items, token);
        if (dataRes.status === 'success') yield put(getMembershipCategory({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementLoadMembership({ payload, token }) {
    try {
        const dataRes = yield settingGetMembership(payload, token);
        if (dataRes.status === 'success') {
            // const dataFilter = dataRes.data.filter(el => el.name_position === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_position !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_membership,
                    value: item.id_membership,
                }
            ));
            yield put(getMembershipSuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddMembership({ payload, token }) {
    try {
        const dataRes = yield settingAddMembership(payload, token);
        if (dataRes.status === 'success') {
            yield put(getMembership({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateMembership({ payload, token }) {
    try {
        const dataRes = yield settingUpdateMembership(payload, token);
        if (dataRes.status === 'success') {
            yield put(getMembership({ spa_id: payload.spa_id }, token));
            // yield put(getMembershipCategory({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// function* settingManagementChangeStatusMembership({ payload, token }) {
//     try {
//         const dataRes = yield settingUpdateChangeStatusMembership(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getMembership({ spa_id: payload.spa_id }, token));

//         } else
//             if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }
//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

function* settingManagementDeleteMembership({ payload, token }) {
    // const { items } = payload;
    // console.log("SSS", payload)
    try {
        const dataRes = yield settingDeleteMembership(payload, token);
        if (dataRes.status === 'success') {
            yield put(getMembership({ spa_id: payload.spa_id }, token));
            // yield put(getAllMembershipCustomer({ spa_id: payload.spa_id }, token));
        }
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// function* settingManagementLoadAllMembershipCustomer({ payload, token }) {
//     try {
//         const dataRes = yield settingGetAllMembershipCustomer(payload, token);
//         if (dataRes.status === 'success') {
//             // let list = [];
//             // const dataFilter = dataRes.data.filter(el => el.name_department === "Owner")
//             // const allDataFilter = dataRes.data.filter(el => el.name_department !== "Owner")
//             // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
//             const list = dataRes.data.map(item => (
//                 {
//                     ...item,
//                     label: `${item.first_name} ${item.last_name}`,
//                     value: item.id_customer,
//                 }
//             ));
//             yield put(getAllMembershipCustomerSuccess(dataRes.data, list));
//         } else
//             if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     } catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// END Membership Management

// Membership Management
export function* watchLoadMembershipCategory() {
    yield takeEvery(
        SETTING_LOAD_MEMBERSHIP_CATEGORY,
        settingManagementLoadMembershipCategory
    );
}
export function* watchAddMembershipCategory() {
    yield takeEvery(
        SETTING_CREATE_MEMBERSHIP_CATEGORY,
        settingManagementAddMembershipCategory
    );
}
export function* watchUpdateMembershipCategory() {
    yield takeEvery(
        SETTING_UPDATE_MEMBERSHIP_CATEGORY,
        settingManagementUpdateMembershipCategory
    );
}
export function* watchDeleteMembershipCategory() {
    yield takeEvery(
        SETTING_DELETE_MEMBERSHIP_CATEGORY,
        settingManagementDeleteMembershipCategory
    );
}

export function* watchLoadMembership() {
    yield takeEvery(
        SETTING_LOAD_MEMBERSHIP,
        settingManagementLoadMembership
    );
}
export function* watchAddMembership() {
    yield takeEvery(
        SETTING_CREATE_MEMBERSHIP,
        settingManagementAddMembership
    );
}
export function* watchUpdateMembership() {
    yield takeEvery(
        SETTING_UPDATE_MEMBERSHIP,
        settingManagementUpdateMembership
    );
}
// export function* watchChangeStatusMembership() {
//     yield takeEvery(
//         SETTING_UPDATE_MEMBERSHIP_STATUS,
//         settingManagementChangeStatusMembership
//     );
// }
export function* watchDeleteMembership() {
    yield takeEvery(
        SETTING_DELETE_MEMBERSHIP,
        settingManagementDeleteMembership
    );
}
// export function* watchLoadAllMembershipCustomer() {
//     yield takeEvery(
//         SETTING_LOAD_ALL_MEMBERSHIP_CUSTOMER,
//         settingManagementLoadAllMembershipCustomer
//     );
// }

// END Membership Management

export default function* rootSaga() {
    yield all([
        //  Membership Management 
        fork(watchLoadMembershipCategory),
        fork(watchAddMembershipCategory),
        fork(watchUpdateMembershipCategory),
        fork(watchDeleteMembershipCategory),

        fork(watchLoadMembership),
        fork(watchAddMembership),
        fork(watchUpdateMembership),
        // fork(watchChangeStatusMembership),
        fork(watchDeleteMembership),

        // fork(watchLoadAllMembershipCustomer),

    ])
}